var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000456268 0.969561C0.00015281 0.979691 0 0.989858 0 1.00006V15.8736L5.42472 12.0001H5.6982e-05L5.72205e-05 6.0001L6.49441 6.0001L0.000456268 0.969561ZM0.587821 17.9114C0.713502 17.9684 0.853049 18.0001 1 18.0001H9.00006V12.0001H8.86639L0.587821 17.9114ZM15.0001 18.0001H21.9852L15.0001 12.589V18.0001ZM23.9995 17.0306C23.9998 17.0204 24 17.0103 24 17.0001V12.0001H17.5057L23.9995 17.0306ZM24 6.0001V1.19392L17.2691 6.0001L24 6.0001ZM22.2303 6.10352e-05H2.01477L9.00006 5.41122V0.000104189H15.0001V5.16281L22.2303 6.10352e-05Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0.0000610352,
    width: 2,
    height: 18,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8.00006,
    width: 2,
    height: 24,
    transform: "rotate(90 24 8.00006)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.cd410bb3b43d44a3590478f7dcef0f4e.svg";
export { ForwardRef as ReactComponent };